export default {"src":"/_next/static/media/loader-transparent-bg.cc72add1.gif","height":200,"width":200,"blurWidth":0,"blurHeight":0};